import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Zap, Shield, Server } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden" data-id="element-1727">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-1728">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-fox-600/20 rounded-full blur-[120px] mix-blend-screen" data-id="element-1729" />
        <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-amber-500/10 rounded-full blur-[150px] mix-blend-screen" data-id="element-1730" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-[0.03]" data-id="element-1731" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-1732">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1733">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-fox-500/10 border border-fox-500/20 text-fox-400 text-sm font-medium mb-8" data-id="element-1734">
            <Zap size={14} className="text-amber-400" data-id="element-1735" />
            <span data-id="element-1736">New: NVMe SSDs on all plans</span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-5xl md:text-7xl font-heading font-bold text-white leading-tight mb-6" data-id="element-1737">
            Hosting That Runs <br className="hidden md:block" data-id="element-1738" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-fox-400 to-amber-500" data-id="element-1739">
              Like a Fox
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-lg md:text-xl text-slate-400 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-1740">
            Lightning-fast, ultra-reliable web hosting with 99.99% uptime.
            Whether you're a small business or an enterprise, we have the tools
            to make your online presence thrive.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1741">
            <a href="#pricing" className="w-full sm:w-auto px-8 py-4 bg-fox-600 hover:bg-fox-500 text-white rounded-full font-medium text-lg transition-all flex items-center justify-center gap-2 shadow-[0_0_20px_rgba(234,88,12,0.4)] hover:shadow-[0_0_30px_rgba(234,88,12,0.6)] hover:-translate-y-1" data-id="element-1742">
              Get Started <ArrowRight size={18} data-id="element-1743" />
            </a>
            <a href="#features" className="w-full sm:w-auto px-8 py-4 bg-slate-800/50 hover:bg-slate-800 text-white border border-slate-700 hover:border-slate-600 rounded-full font-medium text-lg transition-all flex items-center justify-center gap-2 backdrop-blur-sm" data-id="element-1744">
              View Features
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 0.6
        }} className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 border-t border-slate-800/50 pt-10" data-id="element-1745">
            {[{
            icon: Zap,
            label: 'Lightning Fast',
            value: 'NVMe Storage'
          }, {
            icon: Shield,
            label: 'Secure',
            value: 'Free SSL'
          }, {
            icon: Server,
            label: 'Reliable',
            value: '99.99% Uptime'
          }, {
            icon: Zap,
            label: 'Support',
            value: '24/7/365'
          }].map((stat, i) => <div key={i} className="flex flex-col items-center justify-center gap-2" data-id="element-1746">
                <stat.icon className="text-fox-500 mb-2" size={24} data-id="element-1747" />
                <span className="text-white font-semibold" data-id="element-1748">{stat.value}</span>
                <span className="text-slate-400 text-sm" data-id="element-1749">{stat.label}</span>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}